<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Suite';
                }
            },
            component_id: {
                default(){
                    return 'hardware_suite';
                }
            },
            slab: {
                required: true,
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-suite?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
